import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import CheckIcon from '@mui/icons-material/Check';
import { Typography, Box } from '@mui/material';

export default function MyAutocomplete(props) {
  const { field, placeholder, options = [], IsfreeSolo = false, disabled = false, onChange, getOptionLabel, error, helperText, onFocus, onInputChange, defaultValue, value, disableClearable = false, readOnly = false, sx } = props;

  return (
    <Autocomplete
      {...field}
      sx={sx}
      disabled={disabled}
      disableClearable={disableClearable}
      size="small"
      fullWidth
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      onInputChange={onInputChange}
      options={options}
      onFocus={onFocus}
      getOptionLabel={getOptionLabel}
      slotProps={{
        paper: {
          sx: {
            '& .MuiAutocomplete-option[aria-selected="true"]': {
              // backgroundColor: 'primary.light',
              // color: 'primary.main',
              backgroundColor: '#3DBB89 !important',
              color: 'white !important',
            },
            '& .MuiAutocomplete-option.Mui-focused': {
              backgroundColor: '#ECF8F2 !important',
              color: '#3DBB89 !important',
            },
            '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
              backgroundColor: '#3DBB89 !important',
              color: 'white !important',
            },
            '& .MuiAutocomplete-option:hover': {
              backgroundColor: '#ECF8F2 !important',
              color: '#3DBB89 !important',
            },
          },
        },
      }}
      renderOption={(props, option, { selected }) => (
        <Box 
          component="li" 
          {...props} 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            width: '100%',
          }}
        >
          <span>{getOptionLabel ? getOptionLabel(option) : option}</span>
          {selected && <CheckIcon color="white" fontSize="small" sx={{ position: 'absolute', right: 16 }} />}
        </Box>
      )}
      renderInput={(params) => (
        <>
          {(!IsfreeSolo && placeholder) && <Typography variant="h7">{placeholder}</Typography>}
          <TextField
            {...params}
            placeholder={IsfreeSolo && placeholder}
            error={error}
            helperText={helperText}
            inputProps={{
              ...params.inputProps,
              readOnly: readOnly,
              style: { cursor: readOnly ? 'pointer' : 'text' },
            }}
            InputProps={{
              ...params.InputProps,
              ...(IsfreeSolo &&
              {
                startAdornment: (
                  <InputAdornment position="start" sx={{ width: '10px' }}>
                    <SearchIcon color={disabled ? "action" : "primary"} />
                  </InputAdornment>
                )
              }
              )
            }}
          />
        </>
      )}
    />
  );
};